import { TurboMountController } from "turbo-mount";

// Le formulaire de publication (React, monté par turbo-mount). Les médias ne transitent plus
// par lui : ils vivent dans la composition de chaque body, éditée dans son îlot.
export default class extends TurboMountController {
  get componentProps() {
    return {
      ...this.propsValue,
    };
  }
}
